/**
 * Shared theme-aware style constants.
 *
 * All values reference Bootstrap 5 CSS custom properties so they stay in sync
 * with $primary / $secondary defined in src/styles/_theme.scss.
 * When migrating to Tailwind, update the CSS var names here only.
 */

/** Glass-morphism card used across Billing, VoiceClone, API, Podcast etc. */
export const GLASS_CARD = {
    background: 'rgba(255,255,255,0.72)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(var(--bs-primary-rgb), 0.12)',
    borderRadius: '16px',
};

/**
 * Subscription / badge status colours.
 * Uses semantic Bootstrap CSS vars so danger/warning/success update with the theme.
 */
export const STATUS_CONFIG = {
    active:        { color: 'var(--bs-success)',  bg: 'rgba(var(--bs-success-rgb), 0.08)',  border: 'rgba(var(--bs-success-rgb), 0.20)',  label: 'Active' },
    in_trial:      { color: 'var(--bs-primary)',  bg: 'rgba(var(--bs-primary-rgb), 0.08)',  border: 'rgba(var(--bs-primary-rgb), 0.20)',  label: 'In Trial' },
    non_renewing:  { color: 'var(--bs-warning)',  bg: 'rgba(var(--bs-warning-rgb), 0.08)',  border: 'rgba(var(--bs-warning-rgb), 0.20)',  label: 'Non-Renewing' },
    cancelled:     { color: 'var(--bs-danger)',   bg: 'rgba(var(--bs-danger-rgb), 0.08)',   border: 'rgba(var(--bs-danger-rgb), 0.20)',   label: 'Cancelled' },
};

/**
 * Decorative (non-brand) gradients used as feature-card accents.
 * These are intentionally NOT theme tokens — they represent distinct feature
 * categories (Clone Voice = pink/rose, Music = sky, SFX = green).
 * Centralised here so they're easy to find and update.
 */
export const FEATURE_GRADIENTS = {
    clone:  { gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', iconColor: '#f5576c',  lightBg: 'rgba(240,147,251,0.08)' },
    music:  { gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', iconColor: '#4facfe',  lightBg: 'rgba(79,172,254,0.08)'  },
    sfx:    { gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', iconColor: '#38c172',  lightBg: 'rgba(67,233,123,0.08)'  },
};

/**
 * Chart series colours for Recharts / similar libraries that require raw strings.
 * Move to CSS-var-based approach if/when the chart library supports it.
 */
export const CHART_COLORS = {
    primary:   '#2D79F6',
    secondary: '#60B5FF',
    danger:    '#f5576c',
    warning:   '#f093fb',
    axis:      '#A3A3A3',
    line:      '#1F78B4',
    pie:       ['#1F78B4', '#B2DF8A', '#33A02C', '#FB9A99', '#A6CEE3'],
};
